import { useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api-client';
import type { KycProgress } from '@/hooks/useKyc';

export type ReadinessActionKey = 'account' | 'profile' | 'kyc' | 'wallet' | 'subscription' | string;

export interface InvestmentReadinessAction {
  key: ReadinessActionKey;
  label: string;
  route: string;
  complete: boolean;
  blocked?: boolean;
}

export interface InvestmentReadiness {
  account: {
    isAuthenticated: boolean;
    email: string;
    partnerUuid: string;
    profileComplete: boolean;
  };
  kyc: {
    state: string;
    label: string;
    isValidated: boolean;
    isInReview: boolean;
    isRejected: boolean;
    progress?: KycProgress;
    nextRoute: string;
  };
  wallet: {
    state: string;
    label: string;
    isActive: boolean;
    uuid?: string | null;
    walletType?: string | null;
    network?: string | null;
    isPrimary?: boolean;
  };
  canInvest: boolean;
  blockingReason?: string | null;
  requiredActions: InvestmentReadinessAction[];
}

export const investmentReadinessKeys = {
  current: ['me', 'investment-readiness'] as const,
};

export function useInvestmentReadiness(enabled = true) {
  return useQuery({
    queryKey: investmentReadinessKeys.current,
    queryFn: () => apiClient.get<InvestmentReadiness>('/me/investment-readiness'),
    enabled,
    staleTime: 20 * 1000,
    retry: false,
  });
}
